<template>
    <div>
        <base-loading :visible="isLoading" />
        <range-modal :isOpen="rangeModal" @close="rangeModal = false" :isEditing="isEditing" :item="item"
            :client="client" @updated="getList" />
        <confirmation-modal :isOpen="confirmationModal" @close="confirmationModal = false" @accept="deleteRange"
            :item="item" />
        <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-lg="1" vs-sm="3" vs-xs="12" class="p-1">
                <vs-button @click="addRange" class="w-full" icon-pack="feather" icon="icon-plus">{{
                    $t('add') | capitalize }}</vs-button>
            </vs-col>
            <vs-col vs-lg="9" vs-sm="5" vs-xs="0">
            </vs-col>
            <vs-col vs-lg="2" vs-sm="4" vs-xs="12" class="p-1">
                <search-input v-model="search" @handleSearch="doSearch" />
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <range-table :items="items" @loadMore="loadMore()" @edit="editRange" @delete="openConfirmation" />
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import RangeTable from './components/RangeTable.vue'
import SearchInput from '@/views/app/components/inputs/SearchInput.vue'
import RangeModal from './components/RangeModal.vue'
import request from './request'
import ConfirmationModal from '@/views/app/components/modals/ConfirmationModal.vue'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';

export default {
    components: { RangeTable, SearchInput, RangeModal, ConfirmationModal,BaseLoading },
    data() {
        return {
            rangeModal: false,
            confirmationModal: false,
            isEditing: false,
            items: [],
            search: '',
            page: 1,
            lastPage: 1,
            item: {
                id: '',
                startHour: '',
                endHour: '',
                palletPrice: '',
                boxPrice: '',
                bulkPrice: ''
            },
            loading: {
                list: false,
                delete: false,
            }
        }
    },
    computed: {
        client() {
            return this.$route.params.client
        },
        isLoading() {
            return this.loading.list || this.loading.delete
        }
    },

    methods: {
        doSearch() {
            this.page = 1
            this.getList()
        },
        getList() {
            const payload = {
                search: this.search,
                client: this.client,
                page: this.page
            }
            this.loading.list = true
            request.getList(payload)
                .then(response => {
                    if (this.page === 1) {
                        this.items = [...response.data.data]
                    } else {
                        this.items = [...this.items, ...response.data.data]
                    }
                    this.lastPage = response.data.last_page
                    this.page = response.data.current_page
                    this.loading.list = false
                })
                .catch(response => {
                    this.loading.list = false
                    //console.log(response)
                })
        },
        loadMore() {
            if (this.page >= this.lastPage) {
                return
            }
            this.page++
            this.getList()
        },
        addRange() {
            this.rangeModal = true
            this.isEditing = false
        },
        editRange(row) {
            this.rangeModal = true
            this.isEditing = true
            this.item = {
                id: row.id,
                startHour: row.start_hour,
                endHour: row.end_hour,
                palletPrice: row.pallet_price,
                boxPrice: row.box_price,
                bulkPrice: row.bulk_price
            }
        },
        openConfirmation(row) {
            this.confirmationModal = true
            this.item = {
                id: row.id,
                startHour: row.start_hour,
                endHour: row.end_hour,
                palletPrice: row.pallet_price,
                boxPrice: row.box_price,
                bulkPrice: row.bulk_price
            }
        },
        deleteRange(row) {
            this.confirmationModal = false
            const payload = { id: row.id }
            this.loading.delete = true
            request.deleteRange(payload)
                .then(response => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Deleted',
                    })
                    this.loading.delete = false
                    this.getList()
                })
                .catch(response => {
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Oops!',
                        text: 'Something went wrong during the deletion'
                    })
                    this.loading.delete = false
                })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style></style>